<template>
  <div>
    <a-row :gutter="24" type="flex">
      <a-col :span="24" class="mb-24">
        <type-table
          ref="TypeTable"
          :options="cateOptions"
          @addClick="AddClick"
          @editClick="EditClick"
        />
      </a-col>
    </a-row>

    <a-modal
      v-model:open="EditModelVisible"
      :title="amodelTitle"
      :width="amodelWidth"
      :wrap-class-name="amodelHeight"
    >
      <template #footer></template>
      <type-edit
        :typeMod="selTypeMod"
        :options="cateOptions"
        @CancleEdit="CancleEdit"
      ></type-edit>
    </a-modal>
  </div>
</template>

<script>
import { TypeTable, TypeEdit } from "./components/index";
import { getCateSelList } from "@/api/category";

export default {
  components: {
    TypeTable,
    TypeEdit,
  },
  data() {
    return {
      EditModelVisible: false,
      amodelTitle: "分类编辑",
      isMobile: false,
      selTypeMod: {
        id: "",
        keyType: "",
        state: false,
        cateList: [],
      },
      cateOptions: [],
    };
  },
  created() {
    this.GetCateSelList();
  },
  computed: {
    amodelHeight() {
      return this.isMobile ? "full-modal" : "helf-modal";
    },
    amodelWidth() {
      return this.isMobile ? "100%" : "50%";
    },
  },
  methods: {
    GetCateSelList() {
      getCateSelList()
        .then((res) => {
          if (res.code == 0) {
            this.cateOptions = res.data;
          } else {
            this.cateOptions = [];
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    AddClick() {
      this.selTypeMod = {
        id: "",
        keyType: "",
        state: true,
        cateList: [],
      };
      this.amodelTitle = "类型添加";
      this.EditModelVisible = true;
    },
    EditClick(typeMod) {
      this.amodelTitle = "类型编辑";
      this.selTypeMod = Object.assign(typeMod);
      this.selTypeMod.cateIds = this.selTypeMod.cateList.map(
        (item) => item.cateId
      );

      this.EditModelVisible = true;
    },
    CancleEdit() {
      this.EditModelVisible = false;
      this.selTypeMod = {
        id: "",
        keyType: "",
        state: true,
        cateList: [],
      };
      this.$refs.TypeTable.GetTableData();
    },
  },
};
</script>

<style lang="scss">
</style>